<template>
    <section class="banner-section align-items-center">
        <!-- <div class="custom-container">
            <div class="row">
                <div class="col-md-10 col-lg-8">
                    <div class="banner-content">
                        <div class="navbar-brand logo banner-label" style="width:90% !important">
                            <img src="@/assets/img/banner-text.png" class="img-fluid" alt="Logo">
                        </div>
                        <div class="banner-btn">
                            <router-link to="/login" class="btn banner-primary">Ayo Bergabung Sekarang</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
  
        <div class="custom-container">
            <div class="row justify-content-center">
                <div class="col-md-12 col-12 col-sm-12 col-lg">
                    
                        <VueSlickCarousel  v-bind="settings" v-if="lstkatbanner.length">
                            <div class="banner-content" v-for="(ref) in lstkatbanner" :key="ref.id">
                                <img  :src="ref.link_banner" />
                                <!-- <img  :src="loadImg(ref.link_banner)" /> -->
                            </div>
                        <!-- <VueSlickCarousel  v-bind="settings">
                            <div class="banner-content"><img src="@/assets/img/banner-2.jpg" /></div>
                            <div class="banner-content"><img src="@/assets/img/banner-2.jpg" /></div>
                            <div class="banner-content"><img src="@/assets/img/banner-2.jpg" /></div>
                          -->
                        </VueSlickCarousel>
                </div>
            </div>
        </div>

        <!-- <section class="ftco-section bg-light" id="cards">
            <div class="container card-styles">
                <div class="row">
								<div class="col-md-12">
									<div class="card dash-card">
										<div class="card-body">
											<div class="row">
												<div class="col-md-12 col-lg-4">
													<div class="dash-widget dct-border-rht">
													
														<div class="circle-bar circle-bar1">
															<img src="assets/img/icon-01.png" class="img-fluid" alt="Student">
														</div>
														<div class="dash-widget-info">
															<h6>Total Student</h6>
															<h3>1500</h3>
															<p class="text-muted">Till Today</p>
														</div>
													</div>
												</div>
												
												<div class="col-md-12 col-lg-4">
													<div class="dash-widget dct-border-rht">
														<div class="circle-bar circle-bar2">
															<img src="assets/img/icon-02.png" class="img-fluid" alt="Student">
														</div>
														<div class="dash-widget-info">
															<h6>Today Student</h6>
															<h3>160</h3>
															<p class="text-muted">06, Nov 2019</p>
														</div>
													</div>
												</div>
												
												<div class="col-md-12 col-lg-4">
													<div class="dash-widget">
														<div class="circle-bar circle-bar3">
															<img src="assets/img/icon-03.png" class="img-fluid" alt="Student">
														</div>
														<div class="dash-widget-info">
															<h6>Appoinments</h6>
															<h3>85</h3>
															<p class="text-muted">06, Apr 2019</p>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
            </div>
        </section> -->

        <section id="cards" class="ftco-section bg-light align-items-center" v-if="isLoggedIn">
            <div class="container card-styles" >
                <div class="row justify-content-center">
                    <div class="col-md-8 col-11">
                        <div class="card dash-card" style="border-radius: 20px;">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-6 col-lg-6 col-sm-6 col-6">
                                        <div class="dash-widget dct-border-rht">
                                            <div class="circle-bar circle-bar1">
                                                <span class="img-fluid fa-fluid fa fa-wallet"></span>
                                            </div> 
                                            <div class="dash-widget-info">
                                                <h6 class="h6-fluid">Saldo Referral</h6> 
                                                <h3 class="h3-fluid">Rp {{wallet.sisa_saldo}}</h3> 
                                            </div>
                                        </div>
                                    </div> 
                                    <div class="col-md-6 col-lg-6 col-sm-6 col-6">
                                        <div class="dash-widget"> 
                                            <div class="circle-bar circle-bar2">
                                                <span class="img-fluid  fa-fluid fa fa-users" ></span>
                                            </div>
                                            <div class="dash-widget-info">
                                                <h6 class="h6-fluid">Jumlah Referral</h6> 
                                                <h3 class="h3-fluid">{{wallet.jml_trx_referral}} Transaksi</h3> 
                                            </div>
                                        </div>
                                    </div> 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <div class="custom-container">
            <div class="row justify-content-center">
                <div class="col-md-12 col-12 col-sm-12 col-lg">
                    <div class="">
                        <VueSlickCarousel v-bind="settingCategory" v-if="lstkat.length">
                            
                             
                            <div class="widget-profile pro-widget-content" v-for="(ref) in lstkat" :key="ref.id">
                                <!-- <div :class="{'profile-info-widget' : true, 'mt-12' : ref.status!='1'}">
                                    <template v-if="ref.status!='1'">
                                    <div class="bg-warning px-2 pt-1 pb-0.5 comingsoon"><p>COMING SOON</p></div>
                                        
                                    </template>
                                    <router-link :to="'/category?idcat='+ref.id">
                                        <div  :class="{'booking-doc-img booking-doc-img2' : true, 'icon-disable' : ref.status!='1'}">
                                            <img :src="ref.icon" alt="User Image">
                                        </div>
                                        <div :class="{'profile-det-info' : true, 'text-disable' : ref.status!='1'}">
                                            <p>{{ref.nama_kat}}</p>
                                        </div>
                                    </router-link>
                                </div> -->

                                <div v-if="ref.status!='1'" :class="{'profile-info-widget' : true, 'mt-12' : ref.status!='1'}">
                                    <div class="bg-warning px-2 pt-1 pb-0.5 comingsoon"><p>COMING SOON</p></div>
                                        
                                    <div  :class="{'booking-doc-img booking-doc-img2' : true, 'icon-disable' : ref.status!='1'}">
                                        <img :src="ref.icon" alt="User Image">
                                    </div>
                                    <div :class="{'profile-det-info' : true, 'text-disable' : ref.status!='1'}">
                                        <p>{{ref.nama_kat}}</p>
                                    </div>
                                </div>

                                <div v-else :class="{'profile-info-widget' : true, 'mt-12' : ref.status!='1'}">
                                    
                                    <router-link :to="'/category?idcat='+ref.id">
                                        <div  :class="{'booking-doc-img booking-doc-img2' : true, 'icon-disable' : ref.status!='1'}">
                                            <img :src="ref.icon" alt="User Image">
                                        </div>
                                        <div :class="{'profile-det-info' : true, 'text-disable' : ref.status!='1'}">
                                            <p>{{ref.nama_kat}}</p>
                                        </div>
                                    </router-link>
                                </div>
                            </div>

                            <!-- <div class="widget-profile pro-widget-content">
                                <div class="profile-info-widget">
                                    <router-link to="/category?idcat=1">
                                        <div class="booking-doc-img booking-doc-img2">
                                            <img src="https://img.icons8.com/external-microdots-premium-microdot-graphic/64/undefined/external-administration-human-civilization-vol1-microdots-premium-microdot-graphic.png" alt="User Image">
                                        </div>
                                        <div class="profile-det-info">
                                            <p>Kelas CPNS</p>
                                        </div>
                                    </router-link>
                                </div>
                            </div>
                            <div class="widget-profile pro-widget-content">
                                <div class="profile-info-widget">
                                    <a href="#" class="booking-doc-img booking-doc-img2">
                                        <img src="https://img.icons8.com/external-microdots-premium-microdot-graphic/64/undefined/external-citizen-human-civilization-vol1-microdots-premium-microdot-graphic.png" alt="User Image">
                                    </a>
                                    <div class="profile-det-info">
                                        <p>Kelas BUMN</p>
                                    </div>
                                </div>
                            </div>
                            <div class="widget-profile pro-widget-content">
                                <div class="profile-info-widget">
                                    <a href="#" class="booking-doc-img booking-doc-img2">
                                        <img src="https://img.icons8.com/external-microdots-premium-microdot-graphic/64/undefined/external-brainstorm-human-civilization-vol1-microdots-premium-microdot-graphic.png" alt="User Image">
                                    </a>
                                    <div class="profile-det-info">
                                        <p>Pelatihan Soft Skill & Hard Skill</p>
                                    </div>
                                </div>
                            </div>
                            <div class="widget-profile pro-widget-content">
                                <div class="profile-info-widget">
                                    <a href="#" class="booking-doc-img booking-doc-img2">
                                        <img src="https://img.icons8.com/external-vitaliy-gorbachev-flat-vitaly-gorbachev/58/undefined/external-graduation-hat-event-vitaliy-gorbachev-flat-vitaly-gorbachev.png" alt="User Image">
                                    </a>
                                    <div class="profile-det-info">
                                        <p>Sukses PTN & PTK (UTBK & Sekolah Kedinasan)</p>
                                    </div>
                                </div>
                            </div>
                            <div class="widget-profile pro-widget-content">
                                <div class="profile-info-widget">
                                    <a href="#" class="booking-doc-img booking-doc-img2">
                                        <img src="https://img.icons8.com/color/96/undefined/school-building.png" alt="User Image">
                                    </a>
                                    <div class="profile-det-info">
                                        <p>Bimbel SMA</p>
                                    </div>
                                </div>
                            </div>
                            <div class="widget-profile pro-widget-content">
                                <div class="profile-info-widget">
                                    <a href="#" class="booking-doc-img booking-doc-img2">
                                        <img src="https://img.icons8.com/external-flaticons-flat-flat-icons/64/undefined/external-search-seo-flaticons-flat-flat-icons.png" alt="User Image">
                                    </a>
                                    <div class="profile-det-info">
                                        <p>Program Lainnya</p>
                                    </div>
                                </div>
                            </div> -->
                        </VueSlickCarousel>
                        <br><br><br><br><br>
                    </div>
                </div>
            </div>
        </div>

        
    </section> 
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
// import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  // optional style for arrows & dots
// import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

const images = require.context('@/assets/img/banners', false, /\.png$|\.jpg$/)

import {mapGetters} from 'vuex'
import axios from 'axios';
  export default {
    name: 'MyComponent',
    components: { VueSlickCarousel },
    data() {
      return {
        wallet:{sisa_saldo: 0, jml_trx_referral:0},
        lstkat: [],
        lstkatbanner: [],
        settings: {
            // arrows: true,
            dots: true,
            // "infinite": true,
            // // "slidesToShow": 3,
            // "slidesToScroll": 1,
            "autoplay": true,
            // "speed": 2000,
            // "autoplaySpeed": 4000,
            // "cssEase": "linear"
            
            autoplaySpeed: 2500,
            dots: true,
            fade: true,
            // arrows: false,
            // "centerMode": true,
            // "centerPadding": "20px",
            "focusOnSelect": true,
            "infinite": true,
            "slidesToShow": 1,
            "speed": 500
        },
        settingCategory: {
            
            "infinite": true,
            "slidesToShow": 4,
            "speed": 500,
            "rows": 2,
            // "slidesPerRow": 4
            
            // arrows: false,
            // "dots": false,
            // "infinite": false,
            // "speed": 500,
            // "slidesToShow": 6,
            // "slidesToScroll": 6,
            // "initialSlide": 0,
            // "responsive": [
            //     {
            //     "breakpoint": 1024,
            //     "settings": {
            //         "slidesToShow": 3,
            //         "slidesToScroll": 3,
            //         "infinite": true,
            //         "dots": true
            //     }
            //     },
            //     {
            //     "breakpoint": 600,
            //     "settings": {
            //         "slidesToShow": 3,
            //         "slidesToScroll": 3,
            //         "initialSlide": 2
            //     }
            //     },
            //     {
            //     "breakpoint": 480,
            //     "settings": {
            //         "slidesToShow": 4,
            //         // "rows": 2,
            //         // "slidesPerRow": 1
            //         "slidesToScroll": 1
            //     }
            //     }
            // ]
            }
      }
    },
    created:function(){
        this.getAllKategori();
        this.getAllKategoriBanner();
        // if(this.isLoggedIn){
            this.getWalletUser();
        // }
    },
    methods: {
            getAllKategori: function () {
                axios.get('kategori')
                    .then(res => {
                        console.log(res);
                        this.lstkat = res.data.data;
                    })
                    .catch(err => {
                        // handle error
                        console.log(err);
                    })
            },
        getAllKategoriBanner: function () {
            axios.get('kategoribanner/0')
                .then(res => {
                    // console.log(res);
                    this.lstkatbanner = res.data.data;
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
	    loadImg(imgPath) {
            return images('./' + imgPath)        
        },
        // Get Wallet
        getWalletUser: function () {
            axios.get('api/walletusergr/'+this.user.id_user)
                .then(res => {
                    this.wallet = res.data.data;  
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
            
            // getDetail: function (ref) {
            //     if(localStorage.getItem('idUser'))
            //         this.$router.push({name:'siswa-paket-belajar-detail', params: {id: ref.id_paket}});
            //     else
            //         this.$router.push({name:'home-detail-paket', params: {id: ref.id_paket}});

            // },

    },
    computed: {
        ...mapGetters({ 
            isLoggedIn: 'isLoggedIn',
            user: 'user',
        }),
    }
  }
// import { defineComponent } from 'vue';
// // import 'vue3-carousel/dist/carousel.css';
// import { Carousel, Navigation, Slide, Pagination } from 'vue3-carousel';
// export default defineComponent({
//   name: 'ExamplePagination',
//   components: {
//     Pagination,
//     Carousel,
//     Slide,
//     Navigation,
//   },
//   data: () => ({
//     // carousel settings
//     settings: {
//       itemsToShow: 1,
//       snapAlign: 'center',
//     },
//     // breakpoints are mobile first
//     // any settings not specified will fallback to the carousel settings
//     breakpoints: {
//       // 700px and up
//       700: {
//         itemsToShow: 3.5,
//         snapAlign: 'center',
//       },
//       // 1024 and up
//       1024: {
//         itemsToShow: 5,
//         snapAlign: 'start',
//       },
//     },
//   }),
// });

// import { Carousel, Slide } from 'vue-carousel';
// export default {
//   components: {
//     Carousel,
//     Slide
//   }
// };

//   import { ref } from "vue";
// import { MDBCarousel } from "mdb-vue-ui-kit";
//   export default {
//     components: {
//       MDBCarousel
//     },
//     setup() {
//       const items8 = [
//         {
//           src: "https://mdbootstrap.com/img/Photos/Slides/img%20(19).webp",
//           alt: "...",
//           label: "First slide label",
//           caption: "Nulla vitae elit libero, a pharetra augue mollis interdum."
//         },
//         {
//           src: "https://mdbootstrap.com/img/Photos/Slides/img%20(35).webp",
//           alt: "...",
//           label: "Second slide label",
//           caption: "Lorem ipsum dolor sit amet, consectetur adipiscing elit."
//         },
//         {
//           src: "https://mdbootstrap.com/img/Photos/Slides/img%20(40).webp",
//           alt: "...",
//           label: "Third slide label",
//           caption:
//             "Praesent commodo cursus magna, vel scelerisque nisl consectetur."
//         }
//       ];
//       const carousel8 = ref(0);
//       return {
//         items8,
//         carousel8
//       };
//     }
//   };

</script>


// WEBPACK FOOTER //
// src/components/Home/Banner/index.vue